export const state = () => ({
  htmlTemplate: "",
  templates: [],
  loaded: false,
  templatesLoaded: false,
});

export const getters = {
  getTemplate: (state) => state.htmlTemplate,
  getTemplates: (state) => state.templates,
  getTemplateById: (state) => (id) => {
    const numId = Number(id);
    return state.templates.find((t) => t.id === numId) || null;
  },
  isLoaded: (state) => state.loaded,
  isTemplatesLoaded: (state) => state.templatesLoaded,
};

export const mutations = {
  setTemplate(state, htmlTemplate) {
    state.htmlTemplate = htmlTemplate;
    state.loaded = true;
  },
  setTemplates(state, templates) {
    state.templates = Array.isArray(templates) ? templates : [];
    state.templatesLoaded = true;
  },
  reset(state) {
    state.htmlTemplate = "";
    state.templates = [];
    state.loaded = false;
    state.templatesLoaded = false;
  },
};

export const actions = {
  async retrieveEmailTemplate({ commit, state }, { force = false } = {}) {
    if (state.loaded && !force) {
      return;
    }
    try {
      const { data } = await this.$axios.get(
        "/api/manager/mailing-list/template"
      );
      const htmlTemplate = data.view || "";
      commit("setTemplate", htmlTemplate);
    } catch (error) {
      console.error(
        "[email-templates] error:",
        error.response?.status,
        error.message
      );
      commit("setTemplate", "");
    }
  },

  async retrieveEmailTemplates({ commit, state }, { force = false } = {}) {
    if (state.templatesLoaded && !force) {
      return;
    }
    try {
      const { data } = await this.$axios.get(
        "/api/manager/mailing-list/template"
      );
      const templates = Array.isArray(data) ? data : data?.data || [];
      commit("setTemplates", templates);
    } catch (error) {
      console.error(
        "[email-templates] retrieveEmailTemplates error:",
        error.response?.status,
        error.message
      );
      commit("setTemplates", []);
    }
  },

  async retrieveEmailTemplateById(
    { commit, state },
    { id, force = false } = {}
  ) {
    const numId = Number(id);
    const existing = state.templates.find((t) => t.id === numId);
    if (existing && !force) {
      commit("setTemplate", existing.template || "");
      return;
    }
    try {
      const { data } = await this.$axios.get(
        `/api/manager/mailing-list/template/${numId}`
      );
      const htmlTemplate = data.template || data.view || "";
      commit("setTemplate", htmlTemplate);
    } catch (error) {
      console.error(
        "[email-templates] retrieveEmailTemplateById error:",
        error.response?.status,
        error.message
      );
      commit("setTemplate", "");
    }
  },
};
